angular.module('unica_approvation_list.approvation_list_controllers')

.controller('ApprovationListEditController', function(
	$rootScope, $scope, $state, $stateParams,
	ApprovationListListService, ApprovationListEditService
) {

	$rootScope.getEvent( $stateParams.event_id );

	$rootScope.getApprovationList($stateParams.id);

	$scope.saveApprovationList = function() {
		$scope.showLoader();

		ApprovationListEditService
			.update( $rootScope.approvationListData )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					$scope.showSuccessMsg('Lista Approvazione aggiornata con successo!', '');
				}
			});
	};

});